import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';

class SliderHeaderHome {
  constructor() {
    this._init();
  }

  _init() {
    new Swiper('.slider-header-home__slider', {
      modules: [Autoplay, EffectFade],
      effect: 'fade',
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 0,
      grabCursor: true,
      preventInteractionOnTransition: true
    });
  }
}

export const sliderHeaderHome = new SliderHeaderHome();
